import { useState } from "react";
import { useLocation } from "react-router-dom";
import IntelLayout from "../../components/layout/layout";
import FAQPage from "./faq";
import Glossary from "./glossary";
import TrademoTrainingSessions from "@routes/intel/onboarding-screens/onboarding/TrainingSession";

const ResourceCenter = () => {
  const [showNotification, setShowNotification] = useState(false);
  const { search } = useLocation();
  const target = new URLSearchParams(search).get("target");
  return (
    <IntelLayout
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}
      userDetails={() => {
        return;
      }}
      userPlanDetails={() => {
        return;
      }}
      type={"resourceCenter"}
      pageTitle="Help Center | Trademo Intel">
      {target === "glossary" ? <Glossary /> : target === "faqs" ? <FAQPage /> : target === "training-sessions" ? <TrademoTrainingSessions /> : <Glossary />}
    </IntelLayout>
  );
};

export default ResourceCenter;
